import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { UserApi } from '../../../shared/api/eco-drops/user';
import { CampaignWithProgress } from './types';

export const useGetUser = () => {
  return useQuery(['user'], () => UserApi.getUser(), {
    refetchInterval: 30000,
    staleTime: 30000,
    refetchOnWindowFocus: false, // Не рефетчить при возврате фокуса
    refetchOnReconnect: false, // Не рефетчить при переподключении
    refetchOnMount: false, // Не рефетчить при маунте компонента
    retry: false,
  });
};

// Аутентификация пользователя
export const useUserAuth = () => {
  return useMutation(UserApi.auth);
};

export const useUserLogout = () => {
  return useMutation(UserApi.logout);
};

// Аутентификация через Telegram
export const useUserTelegramAuth = () => {
  return useMutation(UserApi.authTelegram);
};

// Получить прогресс пользователя (все кампании или конкретная)
export const useUserProgress = (campaignId?: string, hasUser?: boolean) => {
  return useQuery<CampaignWithProgress>(
    ['user-progress', campaignId],
    () => UserApi.getProgress(campaignId),
    {
      enabled: hasUser,
      refetchInterval: 30000,
      staleTime: 30000,
      refetchOnWindowFocus: false, // Не рефетчить при возврате фокуса
      refetchOnReconnect: false, // Не рефетчить при переподключении
      refetchOnMount: false, // Не рефетчить при маунте компонента
      retry: false,
    },
  );
};

// Установить прогресс пользователя по задаче
export const useSetUserProgress = () => {
  const queryClient = useQueryClient();
  return useMutation(
    ({ campaignId, taskId }: { campaignId: string; taskId: string }) =>
      UserApi.setProgress(campaignId, taskId),
    {
      onSuccess: (_, { campaignId }) => {
        // После успешного обновления прогресса инвалидируем кэш
        queryClient.invalidateQueries(['user-progress', campaignId]);
      },
    },
  );
};
